export const testimonials = [
  {
    id: 'testimonial-001',
    name: '动漫狂热者',
    role: '资深动漫迷',
    avatarSeq: 'user-avatar-001',
    content: '樱花动漫是我用过最好的手机动漫门户！界面简洁清爽，番剧更新速度快，分类也很清晰。每天通勤路上必刷，推荐给所有动漫爱好者。',
    rating: 5,
    isPhoto: false,
  },
  {
    id: 'testimonial-002',
    name: '小林',
    role: '大学生',
    avatarSeq: 'user-avatar-002',
    content: '作为动漫社社长，我经常需要查找各种动漫资讯。樱花动漫的文章质量很高，深度分析和新番导览都很有参考价值。',
    rating: 5,
    isPhoto: false,
  },
  {
    id: 'testimonial-003',
    name: '喵帕斯',
    role: '二次元博主',
    avatarSeq: 'user-avatar-003',
    content: '手机端优化做得特别好，加载速度快，排版也很舒服。分类筛选功能让我能快速找到想看的番，强烈推荐！',
    rating: 5,
    isPhoto: true,
  },
  {
    id: 'testimonial-004',
    name: '星空下的约定',
    role: '上班族动漫迷',
    avatarSeq: 'user-avatar-004',
    content: '下班后的治愈时光就是打开樱花动漫看看最新番剧。内容更新及时，不会错过任何一部好番。',
    rating: 5,
    isPhoto: true,
  },
  {
    id: 'testimonial-005',
    name: '次元旅人',
    role: '自由插画师',
    avatarSeq: 'user-avatar-005',
    content: '不仅番剧资源丰富，文章区的深度分析也让我对很多作品有了新的理解。国漫专区更是良心！',
    rating: 5,
    isPhoto: false,
  },
];

export const mediaReviews = [
  {
    id: 'media-001',
    name: '动漫周刊',
    role: '权威动漫媒体',
    avatarSeq: 'media-avatar-001',
    content: '樱花动漫以其出色的移动端体验和全面的内容覆盖，已成为国内动漫爱好者的首选门户之一。',
    isPhoto: false,
  },
  {
    id: 'media-002',
    name: 'ACG观察站',
    role: '知名二次元媒体',
    avatarSeq: 'media-avatar-002',
    content: '从番剧更新到深度分析，樱花动漫的内容质量在同类型平台中首屈一指。',
    isPhoto: false,
  },
  {
    id: 'media-003',
    name: '二次元专栏',
    role: '站内精选推荐',
    avatarSeq: 'media-avatar-003',
    content: '樱花动漫的国漫专区和文章推荐功能，为广大动漫爱好者提供了一个高质量的交流平台。',
    isPhoto: true,
  },
];

export const aboutTimeline = [
  { year: '2018', title: '梦想起航', description: '樱花动漫正式上线，以手机端为核心打造最优质的动漫浏览体验。' },
  { year: '2019', title: '快速成长', description: '用户突破100万，完成首轮内容生态建设，覆盖主流番剧类型。' },
  { year: '2020', title: '内容深耕', description: '推出深度文章与番剧分析栏目，建立专业编辑团队，内容质量大幅提升。' },
  { year: '2021', title: '国漫专区', description: '开设国漫专区，支持国产动画发展，成为国漫爱好者聚集地。' },
  { year: '2022', title: '技术升级', description: '全面优化移动端体验，加载速度提升300%，用户留存率行业领先。' },
  { year: '2023', title: '社区生态', description: '上线用户评论与互动功能，打造活跃的动漫社区，日活用户突破500万。' },
  { year: '2024', title: '品牌升级', description: '全新品牌视觉升级，与国际动漫IP达成合作，内容更加丰富多元。' },
  { year: '2025', title: '展望未来', description: '持续深耕动漫领域，打造中国最专业、最全面的手机动漫门户平台。' },
];

export const teamMembers = [
  { name: '李樱花', role: '创始人 & CEO', avatarSeq: 'team-avatar-001', description: '资深动漫爱好者，前互联网大厂产品经理，致力于打造最好的动漫平台。' },
  { name: '张动漫', role: '内容总监', avatarSeq: 'team-avatar-002', description: '十年动漫媒体从业经验，资深动漫评论人，曾任职多家动漫杂志。' },
  { name: '王二次', role: '技术负责人', avatarSeq: 'team-avatar-003', description: '全栈工程师，移动端性能优化专家，确保平台流畅的用户体验。' },
  { name: '赵番剧', role: '运营总监', avatarSeq: 'team-avatar-004', description: '擅长社区运营和用户增长，打造了樱花动漫活跃的用户社区生态。' },
];
